<template>
  <payment-single v-if="processComplete"
  :booking-id="bookingId"
  :payment-id="firstPaymentId"></payment-single>
  <div v-else class="container dashboard-block">
    <pickstar-loading class="m-t-lg" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import PaymentSingle from './PaymentSingle'

export default {
  components: {PaymentSingle},

  props: ['bookingId', 'paymentIds', 'action'],

  data () {
    return {
      processComplete: false
    }
  },

  computed: {
    ...mapState('booking', ['booking']),
    ...mapState('payment', ['payment']),

    firstPaymentId () {
      var payments = this.paymentIds.split('-')
      return payments[payments.length - 1]
    }

  },

  methods: {

  },

  created () {
    const payload = {
      token_id: this.$route.query.charge_token,
      payments: this.paymentIds.split('-')
    }
    if (payload.token_id !== null) {
      this.processPayment({ bookingId: this.bookingId, payload }).then(() => {
        this.processComplete = true
      }).catch(() => {
        this.processComplete = true
      })
    }
  }
}
</script>
